// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3VV7_","itemTitle":"ClientEmergencyInfo_itemTitle__3fnaZ","itemText":"ClientEmergencyInfo_itemText__2mt9u"};